
<div>
    <h5>Duplo clique</h5>
    <input type="text" id="{{ inputField.id }}" tabindex="-1"
        placeholder="{{ inputField.placeholder | translate }}"
        pattern="{{ inputField.pattern }}"
        [(ngModel)]="inputField.value"
        (dblclick)="enableGboard()"
        (blur)='disableGboard()'
        maxlength ="{{ inputField.maxLength }}"
        [attr.inputmode]="typeMode"
        #input
	>
</div>
